export default __webpack_public_path__ + "static/media/qt.02b9ce06.png";